import axios from '@utils/axios';

const createMoneyVoucher = {
  state: {
    code: '',
    howMany: 1,
    amount: 0,
    voucherType: 1,
    forWho: '',
    fromWho: '',
    validTo: '',
    usageCount: 1
  },
  mutations: {
    setCode(state, code) {
      state.code = code;
    },
    setHowMany(state, many) {
      state.howMany = many;
    },
    setAmount(state, amount) {
      state.amount = amount;
    },
    setVoucherType(state, type) {
      state.voucherType = type;
    },
    setForWho(state, who) {
      state.forWho = who;
    },
    setFromWho(state, who) {
      state.fromWho = who;
    },
    setValidTo(state, to) {
      state.validTo = to;
    },
    setUsageCount(state, usageCount) {
      state.usageCount = usageCount;
    }
  },
  actions: {
    createVoucher(context) {
      return axios.put('admin/vouchers/create-money-voucher', {
        Code: context.state.code,
        HowMany: context.state.howMany,
        Amount: Number(context.state.amount),
        VoucherType: Number(context.state.voucherType),
        ValidTo: context.state.validTo,
        ForWho: Number(context.state.voucherType) === 2 ? context.state.forWho : '',
        FromWho: Number(context.state.voucherType) === 2 ? context.state.fromWho : '',
        UsageCount: Number(context.state.usageCount)
      });
    },
    resetContext(context) {
      context.commit('setCode', '');
      context.commit('setHowMany', 1);
      context.commit('setAmount', 0);
      context.commit('setVoucherType', 1);
      context.commit('setValidTo', '');
      context.commit('setForWho', '');
      context.commit('setFromWho', '');
      context.commit('setUsageCount', 1);
    },
  },
  namespaced: true
};

export default createMoneyVoucher;
